<template>
  <AIVDialog v-model="visible" title="Client Summary of Training (CST)" width="90%" height="85vh">
    <div v-if="cst" class="cst-view">
      <div class="cst-view__header">
        <h5>{{ cst.client_first_name }} {{ cst.client_last_name }}</h5>
        <el-tag size="small" :type="cst.status === 'active' ? 'success' : 'warning'">
          {{ cst.status }} (v{{ cst.version }})
        </el-tag>
      </div>

      <div class="cst-view__grid">
        <div class="cst-view__field" v-if="cst.goes_by"><label>Goes By</label><p>{{ cst.goes_by }}</p></div>
        <div class="cst-view__field" v-if="cst.dob"><label>DOB</label><p>{{ cst.dob }}</p></div>
        <div class="cst-view__field" v-if="cst.gender"><label>Gender</label><p>{{ cst.gender }}</p></div>
        <div class="cst-view__field" v-if="cst.dnr"><label>DNR</label><p>{{ cst.dnr }}</p></div>
      </div>

      <div class="cst-view__sections">
        <div v-for="section in filteredSections" :key="section.key" class="cst-view__section">
          <h6>{{ section.label }}</h6>
          <p>{{ cst[section.key] }}</p>
        </div>
      </div>

      <!-- Emergency Contacts -->
      <div v-if="cst.emergencyContacts && cst.emergencyContacts.length > 0" class="cst-view__table-section">
        <h6>Emergency Contacts</h6>
        <el-table :data="cst.emergencyContacts" stripe size="mini">
          <el-table-column prop="name" label="Name" />
          <el-table-column prop="relationship" label="Relationship" />
          <el-table-column prop="phone" label="Phone" />
        </el-table>
      </div>

      <!-- Medications -->
      <div v-if="cst.medications && cst.medications.length > 0" class="cst-view__table-section">
        <h6>Medications</h6>
        <el-table :data="cst.medications" stripe size="mini">
          <el-table-column prop="name" label="Name" />
          <el-table-column prop="dosage" label="Dosage" />
          <el-table-column prop="frequency" label="Frequency" />
          <el-table-column prop="route" label="Route" />
          <el-table-column prop="instructions" label="Instructions" />
        </el-table>
      </div>

      <!-- Responsible Parties -->
      <div v-if="cst.responsibleParties && cst.responsibleParties.length > 0" class="cst-view__table-section">
        <h6>Responsible Parties</h6>
        <el-table :data="cst.responsibleParties" stripe size="mini">
          <el-table-column prop="name" label="Name" />
          <el-table-column prop="relationship" label="Relationship" />
          <el-table-column prop="phone" label="Phone" />
          <el-table-column prop="email" label="Email" />
        </el-table>
      </div>
    </div>
    <div v-else class="text-center py-4" style="color: #b3a6a6;">No CST data available.</div>
  </AIVDialog>
</template>

<script>
export default {
  name: "CstViewModal",
  props: {
    value: { type: Boolean, default: false },
    cst: { type: Object, default: null },
  },
  data() {
    return {
      sections: [
        { key: "goals", label: "Goals" },
        { key: "daily_service_routine", label: "Daily Service Routine" },
        { key: "dietary_needs", label: "Dietary Needs" },
        { key: "functional_limitations", label: "Functional Limitations" },
        { key: "medical_needs", label: "Medical Needs" },
        { key: "bathroom_needs", label: "Bathroom Needs" },
        { key: "transportation_needs", label: "Transportation Needs" },
        { key: "preferences_communication", label: "Communication Preferences" },
        { key: "likes", label: "Likes" },
        { key: "dislikes", label: "Dislikes" },
        { key: "non_negotiable_routines", label: "Non-Negotiable Routines" },
        { key: "behaviors", label: "Behaviors" },
        { key: "behavior_intervention", label: "Behavior Intervention" },
        { key: "bsp_reference", label: "BSP Reference" },
        { key: "human_rights_restrictions", label: "Human Rights Restrictions" },
        { key: "natural_supports", label: "Natural Supports" },
      ],
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    filteredSections() {
      if (!this.cst) return [];
      return this.sections.filter(s => this.cst[s.key]);
    },
  },
};
</script>

<style scoped>
.cst-view__header { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; }
.cst-view__header h5 { color: #fff; margin: 0; }
.cst-view__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem; }
.cst-view__field label { display: block; color: #b3a6a6; font-size: 0.8rem; }
.cst-view__field p { color: #e0e0e0; margin: 0; }
.cst-view__sections { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 1rem; margin-bottom: 1.5rem; }
.cst-view__section { background: rgba(0, 0, 0, 0.15); border-radius: 6px; padding: 0.75rem; }
.cst-view__section h6 { color: #447DF7; font-size: 0.85rem; margin-bottom: 0.4rem; }
.cst-view__section p { color: #e0e0e0; font-size: 0.9rem; margin: 0; white-space: pre-wrap; }
.cst-view__table-section { margin-bottom: 1.5rem; }
.cst-view__table-section h6 { color: #447DF7; margin-bottom: 0.5rem; }
</style>
